<div class="card-header">
    <span>
        Spectacle Vendors
    </span>
    <button class="btn btn-sm btn-warning float-right" style="margin-top: -4px;" (click)="inviteNewVendor()">
        <i class="fa fa-plus"></i>
        Add/Invite New Vendor
    </button>
</div>

<div class="content-body padding-top-20 padding-bottom-20">
    <div class="row">
        <p-table [value]="customersOnboarded" [paginator]="customersOnboarded!=null && customersOnboarded.length>10"
            [rows]="10" #dt>
            <ng-template pTemplate="header">
                <tr>
                    <th style="width:50px;text-align: center;">#
                    </th>
                    <th [pSortableColumn]="'providerName'">Vendor Name
                        <p-sortIcon [field]="'providerName'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'email'">Contact Details
                        <p-sortIcon [field]="'email'"></p-sortIcon>
                    </th>
                    <th>
                        Status
                    </th>
                    <th style="width: 150px;">
                        Action
                    </th>
                </tr>
                <tr *ngIf="customersOnboarded==null || customersOnboarded.length==0"
                    style="border-left: 1px solid #f4f4f4;border-right: 1px solid #f4f4f4;border-bottom: 1px solid #f4f4f4;">
                    <td colspan="5">
                        <div style="padding: 5px;text-align: center;">
                            No record found
                        </div>
                    </td>
                </tr>
                <tr *ngIf="customersOnboarded!=null && customersOnboarded.length>0">
                    <td class="primeng-table-search">
                        <input class="primeng-table-search-field" disabled pInputText type="text" />
                    </td>
                    <td class="primeng-table-search">
                        <input class="primeng-table-search-field" placeholder="search by name" pInputText type="text"
                            (input)="dt.filter($event.target.value, 'providerName', 'contains')">
                    </td>
                    <td class="primeng-table-search">
                        <input class="primeng-table-search-field" placeholder="search by email" pInputText type="text"
                            (input)="dt.filter($event.target.value, 'email', 'contains')">
                    <!-- </td> -->
                    <td class="primeng-table-search">
                        <input class="primeng-table-search-field" disabled pInputText type="text" />
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-vendor let-i="rowIndex">
                <tr style="cursor: pointer;">
                    <td style="text-align: center;">
                        {{i+1}}
                    </td>
                    <td>{{vendor.providerName}}
                    </td>
                    <td>{{vendor.email}} <br />
                        {{vendor.mobile}}
                    </td>
                    <td>
                        <span class="badge badge-success" style="font-size: 13px;"
                            *ngIf="vendor.isOnBoardingCompleted && !vendor.isIniviteLinkExpired">Onboarding
                            completed</span>
                        <span class="badge badge-warning" style="font-size: 13px;"
                            *ngIf="!vendor.isOnBoardingCompleted && !vendor.isIniviteLinkExpired">Yet to Signup</span>
                        <span class="badge badge-danger" style="font-size: 13px;"
                            *ngIf="vendor.isIniviteLinkExpired">Link
                            Expired</span>
                    </td>
                    <td>
                        <button *ngIf="!vendor.isOnBoardingCompleted" class="btn btn-xs btn-warning"
                            (click)="resendLink(vendor)">
                            <i class="fa fa-share"></i>
                            Resend Link
                        </button>
                        <span *ngIf="vendor.isOnBoardingCompleted">NA</span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>